import { RouterProvider } from 'react-router-dom';
// Side-effect import: registers the `beforeinstallprompt` listener as early
// as possible in the app's lifecycle. See src/lib/installPrompt.ts — the
// event can only be captured once, at the moment the browser fires it, so
// this must not wait for a lazy route chunk or a component mount.
import '@/lib/installPrompt';
import { Providers } from './providers';
import { router } from './router';

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
